import * as types from './types';
import { IPolicy, IResource } from '@src/pages/Precision/PrecisionPolicy/types';
import update from 'immutability-helper';

export enum ViewTypes {
  policies = 'policies',
  schedules = 'schedules',
}

interface IState {
  policies: IPolicy[];
  resources: IResource[];
  can_edit: boolean;
  loading: boolean;
  modalVisible: boolean;
  submitting: boolean;
  sortable: boolean;
  activeView: ViewTypes;
}

const initialState: IState = {
  policies: [],
  resources: [],
  can_edit: false,
  loading: false,
  modalVisible: false,
  submitting: false,
  sortable: false,
  activeView: ViewTypes.policies,
};

const reducerMap: {
  [key in keyof typeof types]?: (
    state: IState,
    action: Partial<{ type: keyof typeof types }>,
  ) => IState;
} = Object.create(null);

reducerMap[types.SET_DATA] = (_, action) => ({
  ...initialState,
  ...action.data,
});

reducerMap[types.TOGGLE_SORTABLE] = (state, action) =>
  update(state, {
    sortable: { $set: action.status },
  });

reducerMap[types.TOGGLE_LOADING] = (state, action) =>
  update(state, {
    loading: { $set: action.status },
  });

reducerMap[types.TOGGLE_MODAL] = (state, action) =>
  update(state, {
    modalVisible: { $set: action.status },
  });

reducerMap[types.TOGGLE_SUBMITTING] = (state, action) =>
  update(state, {
    submitting: { $set: action.status },
  });

reducerMap[types.SET_VIEW] = (state, action) =>
  update(state, {
    activeView: { $set: action.view },
  });

export default (state = initialState, action) =>
  reducerMap[action.type] ? reducerMap[action.type](state, action) : state;
